import type { MainActions } from '@confluence/content-types-header/entry-points/MainActions.tsx';

import { ContentTypesActionsService } from './content-types-actions-service.ts';

export const contentMainActionsService = new ContentTypesActionsService<MainActions>();
